new Swiper(".review-slider", {
  pagination: {
    el: ".swiper-pagination",
    clickable: true,   // makes the dots clickable
  },
  // loop: true,
  autoplay: {
    delay: 2500,
    disableOnInteraction: false 
  },
  speed: 800,
  grabCursor: true, 
  allowTouchMove: true, 
  slidesPerView: 3,
  spaceBetween: 30,
  breakpoints: {
    0: {         
      slidesPerView: 1,
      spaceBetween: 10
    },
    768: {        
      slidesPerView: 2,
      spaceBetween: 20
    },
    1024: {      
      slidesPerView: 3,
      spaceBetween: 30
    }
  }
});